import { QueryClient } from '@tanstack/react-query';
import { isApiError } from '@saas/ui';

/**
 * react-query の既定。
 *   - 4xx は再試行しない（権限・検証エラーは何度やっても同じ）。到達不能と 5xx だけ 2 回まで
 *   - 画面に戻ったときの自動再取得は控えめに（現場の回線を無駄にしない）
 * クエリキーは各モジュールの ui/api.ts（coreKeys / workflowKeys / expenseKeys）が持つ。
 */
export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        refetchOnWindowFocus: false,
        retry: (count, err) => {
          if (isApiError(err) && err.status >= 400 && err.status < 500) return false;
          return count < 2;
        },
      },
      mutations: { retry: 0 },
    },
  });
}
